import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PernyataanKenaikanKelasSvc from "@/services/PernyataanKenaikanKelas";

@Module({ store, dynamic: true, namespaced: true, name: "pernyataan-kenaikan-kelas" })
class PernyataanKenaikanKelasModule extends VuexModule {
  list: any[] = [];
  loading = false;

  @Mutation SET_LIST(val: any[]) {
    this.list = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await PernyataanKenaikanKelasSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_LIST(data || []);
    } catch {
      this.SET_LIST([]);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_LIST([]);
  }
}

export const storePernyataanKenaikanKelas = getModule(PernyataanKenaikanKelasModule);
